import { delay, takeLatest } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import {
  COMMON_UPLOAD_FILE_BEGIN,
  COMMON_UPLOAD_FILE_SUCCESS,
  COMMON_UPLOAD_FILE_FAILURE,
  COMMON_UPLOAD_FILE_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';
import { LoopBackAuth } from '../../../sdk/services';
import { LoopBackConfig } from '../../../sdk';

import axios from 'axios';
const axiosInstance = axios.create();

export function uploadFile(container, files = [], dados = {}) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: COMMON_UPLOAD_FILE_BEGIN,
    container,
    files,
    dados,
  };
}

export function dismissUploadFileError() {
  return {
    type: COMMON_UPLOAD_FILE_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on COMMON_UPLOAD_FILE_BEGIN actions
export function* doUploadFile(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  try {
    const Api = new Services['ContainerApi']();
    try {
      yield Api.getContainer(action.container);
    } catch (error) {
      yield Api.createContainer({ name: action.container });
    }
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    let url = `${LoopBackConfig.getPath()}/${LoopBackConfig.getApiVersion()}/container/${
      action.container
    }/upload`;

    const formData = new FormData();

    const objKeys = Object.keys(action.dados);

    if (objKeys.length > 0) {
      let listParamUrl = [];
      objKeys.forEach(campo => {
        //  console.log(campo);
        formData.append(campo, action.dados[campo]);
        listParamUrl.push(`${campo}=${action.dados[campo]}`);
      });

      url = `${url}?${listParamUrl.join('&')}`;
    }

    action.files.forEach(file => {
      formData.append('files', file);
    });

    const auth = new LoopBackAuth();

    const headers = {
      'Content-Type': 'multipart/form-data',
      Authorization: LoopBackConfig.getAuthPrefix() + auth.getAccessTokenId(),
    };

    res = yield axiosInstance.post(url, formData, {
      headers,
    });

    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield call(delay, 20);
  } catch (err) {
    yield put({
      type: COMMON_UPLOAD_FILE_FAILURE,
      data: { error: err },
    });
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: COMMON_UPLOAD_FILE_SUCCESS,
    data: res,
  });
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchUploadFile() {
  yield takeLatest(COMMON_UPLOAD_FILE_BEGIN, doUploadFile);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case COMMON_UPLOAD_FILE_BEGIN:
      return {
        ...state,
        uploadFilePending: true,
        uploadFileError: null,
      };

    case COMMON_UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        uploadFilePending: false,
        uploadFileError: null,
      };

    case COMMON_UPLOAD_FILE_FAILURE:
      return {
        ...state,
        uploadFilePending: false,
        uploadFileError: action.data.error,
      };

    case COMMON_UPLOAD_FILE_DISMISS_ERROR:
      return {
        ...state,
        uploadFileError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/uploadFile.js